import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { PluginTemplate } from "types/generated";
import { AccessResult, NO_ACCESS_MESSAGE } from "utils/access";
import { AccountContext } from "views/AccountWrapper";

const useCanDeletePluginTemplates = (): ((template: PluginTemplate) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (template) => {
      if (template.isGlobal) {
        return { result: false, message: "Only account-level templates can be deleted" };
      }

      if (viewer.admin) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useCanDeletePluginTemplates;
